var map = {
	"./Framabag.vue": 116,
	"./Framabee.vue": 114,
	"./Framabin.vue": 117,
	"./Framaboard.vue": 118,
	"./Framabookin.vue": 119,
	"./Framacalc.vue": 120,
	"./Framaclic.vue": 121,
	"./Framadrive.vue": 122,
	"./Framadrop.vue": 123,
	"./Framaestro.vue": 124,
	"./Framalink.vue": 125,
	"./Framanews.vue": 126,
	"./Framanotes.vue": 127,
	"./Framapack.vue": 128,
	"./Framapiaf.vue": 129,
	"./Framapic.vue": 130,
	"./Framasite.vue": 131,
	"./Framaslides.vue": 132,
	"./Framasphere.vue": 133,
	"./Framastory.vue": 134,
	"./Framavectoriel.vue": 135,
	"./Framawiki.vue": 136,
	"./Framemo.vue": 137,
	"./Framindmap.vue": 138,
	"./Home.vue": 115,
	"./Mumble.vue": 139,
	"./Myframa.vue": 140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;